module.exports = __webpack_public_path__ + "static/media/java-beginner.e26bd982.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/java-beginner.png
// module id = 1461
// module chunks = 147